export const VISIBILITY_VALUES = ['private', 'public'] as const;
export type VisibilityToggleGroupValue = (typeof VISIBILITY_VALUES)[number];
export type VisibilityToggleGroupVariant = 'radio' | 'checkbox';

export type VisibilityToggleGroupPropsMicrocopy = {
  groupLabel: string;
  private: string;
  privateHelp: string;
  public: string;
  publicHelp: string;
};

export type VisibilityToggleGroupPropsData = {
  value: VisibilityToggleGroupValue;
  variant?: VisibilityToggleGroupVariant;
  showTitleIcon?: boolean;
};

export type VisibilityToggleGroupPropsDataWithMicrocopy =
  VisibilityToggleGroupPropsData & {
    microcopy: VisibilityToggleGroupPropsMicrocopy;
  };

export type VisibilityToggleGroupPropsActions = {
  onValueChange: (value: VisibilityToggleGroupValue) => void;
};

export type VisibilityToggleGroupProps =
  VisibilityToggleGroupPropsDataWithMicrocopy &
    VisibilityToggleGroupPropsActions & {
      className?: string;
    };

export type VisibilityToggleGroupOption = {
  value: VisibilityToggleGroupValue;
  iconName: string;
  label: string;
  helpText: string;
};
